import React from "react";
import "./Common_Title.css";

const Common_Title = ({ pageTitle, subTitle,darkText,simpleText }) => {
  return (
    <div className="Common_Title">
      {pageTitle && <p className="page_title">{pageTitle}</p>}
      {subTitle && <p className="box_text">{subTitle}</p>}    
      {simpleText && <p className="simple_text">{simpleText}</p>}    
    </div>
  );
};

export default Common_Title;
